import HowItWorkSection from './HowItWorksSection';

export default HowItWorkSection;
